import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Popover, Stack, Typography, Skeleton } from '@mui/material'
import { AutoAwesome } from '@mui/icons-material'

const ImageAnalyzer = ({ imageUrl }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [answer, setAnswer] = useState('')
  const [isAnswerLoading, setIsAnswerLoading] = useState(false)

  const open = Boolean(anchorEl)

  const handleClick = async event => {
    setAnchorEl(event.currentTarget)
    setIsAnswerLoading(true)
    try {
      const apiRequestBody = {
        model: 'gpt-4-turbo',
        messages: [
          {
            role: 'user',
            content: [
              {
                type: 'text',
                text: `You are an expert on metals. In the provided image, you will see some metal.
                The metal may be placed in the bed of a truck or on the ground or on a scale.
                Use context clues and your expertise on metals to identify the metal in the image.
                It is okay to be wrong, just give it your best guess.
                Instead of saying scrap metal, try to say what type of metals might be in there.
                If it's copper, try to give a copper grade like bare bright, #1, #2, etc.
                The photo might not show raw metal, but a product made from metal. If that's the case,
                try to identify the metal used in the product.
                Reply in the following format:
                'Metal Name (% confidence)'
                `,
              },
              {
                type: 'image_url',
                image_url: { url: imageUrl },
              },
            ],
          },
        ],
        max_tokens: 300,
      }

      const response = await fetch('https://api.openai.com/v1/chat/completions', {
        method: 'POST',
        headers: {
          Authorization: 'Bearer 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',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(apiRequestBody),
      })

      const gptData = await response.json()
      if (gptData.choices && gptData.choices[0] && gptData.choices[0].message) {
        setAnswer(gptData.choices[0].message.content)
      } else {
        setAnswer('Image might not be clear enough.')
      }
      setIsAnswerLoading(false)
    } catch (error) {
      console.error(error)
      setAnswer('An error occurred.')
      setIsAnswerLoading(false)
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const renderPopoverContent = () => {
    if (isAnswerLoading) {
      return <Skeleton animation="wave" variant="text" width={300} height={50} sx={{ margin: '16px' }} />
    }
    return (
      <Stack spacing={1} style={{ padding: '16px', maxWidth: '300px', minWidth: '300px' }}>
        <Typography variant="body1">{answer}</Typography>
        <Typography variant="caption" color="text.secondary">
          Powered by AI. Answers may not be accurate.
        </Typography>
      </Stack>
    )
  }

  return (
    <div>
      <Button variant="contained" size="small" color="primary" onClick={handleClick}>
        <AutoAwesome />
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {renderPopoverContent()}
      </Popover>
    </div>
  )
}

ImageAnalyzer.propTypes = {
  imageUrl: PropTypes.string.isRequired,
}

export default ImageAnalyzer
